import lrEditTable from './_src/lrEditTable.vue'

lrEditTable.install = function(Vue) {
  Vue.component(lrEditTable.name, lrEditTable)
}

export default lrEditTable